(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/dialog-wager-content/assets/javascripts/dialog-wager-content.js') >= 0) return;  svs.modules.push('/components/racing/dialog-wager-content/assets/javascripts/dialog-wager-content.js');
"use strict";


const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const playUrl = svs.core.urlMapping.get('racing');
const {
  ImageTypes,
  getImageOptions
} = svs.racing.common.imageOptions;
const {
  gameTypes
} = svs.racing.common.constants;
(function (svs) {
  'use strict';

  const parseSelections = (selections, participants, silksFormattedDate) => {
    const participentItem = [];
    const showMoreInfo = selections.length === 1;
    if (selections.length === 1) {
      const currentParticipant = participants.filter(participant => participant.participantNumber === selections[0])[0];
      const imageOptions = (currentParticipant === null || currentParticipant === void 0 ? void 0 : currentParticipant.silks) && silksFormattedDate && getImageOptions(currentParticipant.silks, silksFormattedDate, ImageTypes.CouponSilk);
      participentItem.push({
        showMoreInfo,
        driver: currentParticipant.driverName,
        imageOptions,
        horse: currentParticipant.horseName,
        participantNumber: currentParticipant.participantNumber
      });
    } else {
      selections.forEach(participant => {
        participentItem.push({
          participantNumber: participant
        });
      });
    }
    return participentItem;
  };
  const handleRowToCoupon = (options, toRaceWithRow) => {
    const race = options.race;
    toRaceWithRow(race.meeting.formattedDate, race.meeting.track.urlName, race.raceNumber, options.row, svs.core.detect.feature('ft-racing-cross-sell-duo') ? gameTypes.TOPP2 : gameTypes.RX4IO, svs.core.detect.formfactor.mobile());
    svs.components.dialog.api.close();
  };
  const normalizeRowToCoupon = selections => {
    const normalizedRow = new Array(selections.length);
    for (let i = 0; i < selections.length; i++) {
      for (let k = 0; k < selections[i].length; k++) {
        const pixPosition = selections[i][k] - 1;
        const previousValue = normalizedRow[pixPosition] ? normalizedRow[pixPosition] : 0;
        const newValue = previousValue | 1 << i;
        normalizedRow[pixPosition] = newValue;
      }
    }
    return normalizedRow;
  };
  svs.racing.dialog_wager_content = function (wager, participants, race, toRaceWithRow) {
    const {
      buildLocationFromRaceWithRow,
      locationToUrl
    } = svs.racing.navigation.location;
    const {
      meeting
    } = race;
    const el = document.createElement('div');
    let selections = wager.rxBoards[0].systemType[0] === 'RX_MATHPOS' ? wager.rxBoards[0].rxRaces : wager.rxBoards[0].extras.map(selection => [selection]);
    if (svs.core.detect.feature('ft-racing-cross-sell-duo')) {
      selections = wager.rxBoards[0].rxRaces[1].map(selection => [selection]);
    }
    const parsedSelections = selections.map(selection => parseSelections(selection, participants, meeting.silksFormattedDate));
    const reserve = wager.rxBoards[0].replacement;
    let parsedReserve;
    if (reserve) {
      const reserveHorse = participants ? participants.filter(x => x.participantNumber === reserve)[0] : undefined;
      const reserveHorseName = reserveHorse ? reserveHorse.horseName : undefined;
      const reserveHorseNumber = reserveHorse ? reserveHorse.participantNumber : undefined;
      parsedReserve = {
        horse: reserveHorseName,
        participantNumber: reserveHorseNumber
      };
    }
    const meetingString = "".concat(formatDate(race.startTime, true, true, true), ", ").concat(meeting.track.name, ", Lopp ").concat(meeting.meetingNumber);
    el.innerHTML = svs.racing.dialog_wager_content.templates.content({
      rows: parsedSelections,
      reserve: parsedReserve,
      meeting: meetingString
    });
    const toCouponBtn = el.getElementsByClassName('js-row-to-coupon-btn');
    toCouponBtn[0].addEventListener('click', () => {
      if (toRaceWithRow) {
        const options = {
          row: normalizeRowToCoupon(selections),
          race
        };
        handleRowToCoupon(options, toRaceWithRow);
      } else {
        const path = buildLocationFromRaceWithRow(race, normalizeRowToCoupon(selections));
        path.pathname = svs.core.detect.feature('ft-racing-cross-sell-duo') ? path.pathname.replace('high-five', 'duo') : path.pathname.replace('high-five', 'high-4');
        const raceUrlWithBag = "".concat(playUrl, "/").concat(locationToUrl(path));
        window.location.href = raceUrlWithBag;
      }
    });
    return el;
  };
})(svs);

 })(window);